export const LS_TOKEN = "swar_token";
export const LS_ROLE = "swar_role";
export const LS_CANDIDATE_ID = "swar_candidate_id";
export const LS_HR_ID = "swar_hr_id";
export const LS_ABANDON_QUEUE = "swar_abandon_queue_v1";
/** sessionStorage: guest job apply CV + jobId before login/register */
export const SS_PENDING_JOB_APPLY = "swar_pending_job_apply";
